import { useLocation } from 'react-router-dom';
import { hooks as commonHooks } from '@sitebuilder/common';

interface PropsShape {
    column: Record<string, string>;
    data: Record<string, any>;
    fundUrlMapping: {
        parameters: {
            key: string;
            value: string;
        }[];
        fundUrlTag: string;
    }[];
    fundUrl: string;
    fundUrlBase: string;
    dataContext: any;
}

export default function FundNameTableCell(props: PropsShape) {
    const { column, data, fundUrlMapping, fundUrl, fundUrlBase, dataContext } = props;
    const value = data[column.id];

    // TODO: Implement logic
    const isIncludedInUserList = false;

    const location = useLocation();
    const search = location?.search;
    const params = new URLSearchParams(search);

    const i18n = commonHooks.useLocalization();

    let fundURL = fundUrl
        ? i18n.format(fundUrl, data)
        : `/${fundUrlBase || 'fund-profile'}?profileId=${data.entityId}&locale=${i18n.getLocale()}`;

    if (fundUrlMapping) {
        fundUrlMapping.forEach((u) => {
            const parametersToCheck = u.parameters;

            const doParamsMatchCondition = parametersToCheck.every((p) => {
                const paramValue = params.get(p.key) || null;
                return paramValue === p.value;
            });

            if (doParamsMatchCondition) {
                const mappedFundUrl = (data?.relatedDocuments || []).find(
                    (d: any) => d.tags === u.fundUrlTag
                );

                if (mappedFundUrl && mappedFundUrl.url) {
                    fundURL = mappedFundUrl.url;
                }
            }
        });
    }

    return (
        <td
            key={column.id}
            className="col col--name"
            data-label={i18n.format(column.label, dataContext)}
            data-column-id={column.id}
        >
            <span className="flex-wrapper">
                <a
                    id="fund-link"
                    href={fundURL}
                    dangerouslySetInnerHTML={{ __html: value }}
                    target="_blank"
                    rel="noopener noreferrer"
                />

                <span className={`${isIncludedInUserList ? 'user-check' : ''}`}>
                    {isIncludedInUserList && (
                        <span className={'fas fa-user-check user-list-indicator'}></span>
                    )}
                </span>
            </span>
        </td>
    );
}
